import { ReactNode, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AppConfig } from "../../AppConfig";
import { PageRoutes } from "../../constants/routes";
import { LocalStorageManager } from "../../core/storage/LocalStorageManager";
import { authActions, authSelectors } from "../../ducks/auth";

type Props = {
  requiredLogin?: boolean;
  requiredLogout?: boolean;
  redirectToLogin?: boolean;
  children?: ReactNode;
};

export const AuthTemplate: React.FC<Props> = ({
  requiredLogin,
  requiredLogout,
  redirectToLogin,
  children,
}) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);

  const location = useLocation();
  const dispatch = useDispatch();

  const isLoggedInStore = useSelector(authSelectors.isLoggedIn);
  const loggedInUser = useSelector(authSelectors.loggedInUser);

  useEffect(() => {
    setIsLoggedIn(isLoggedInStore);
  }, [isLoggedInStore]);

  useEffect(() => {
    const accessToken = LocalStorageManager.Instance.getObject<string>(
      AppConfig.Instance.LocalStorageKey["accessToken"],
    );

    dispatch(authActions.setIsLoggedIn(Boolean(accessToken)));
    setIsLoggedIn(Boolean(accessToken));
  }, []);

  useEffect(() => {
    if (requiredLogout) {
      LocalStorageManager.Instance.removeObject(
        AppConfig.Instance.LocalStorageKey["accessToken"],
      );
      dispatch(authActions.setIsLoggedIn(false));
      setIsLoggedIn(false);

      return;
    }

    if (
      requiredLogin ||
      (isLoggedIn && loggedInUser === null) ||
      loggedInUser !== null
    ) {
      dispatch(authActions.getUser.started({}));
    }
  }, [location.pathname, isLoggedIn]);

  if (isLoggedIn === null) return null;

  if (requiredLogin && !isLoggedIn) {
    const redirectPath = window.location.hash.substring(1) ?? undefined;
    const state = { redirectPath };

    if (redirectToLogin) {
      return <Navigate replace to={PageRoutes.LOGIN} state={state} />;
    }

    return <Navigate replace to={PageRoutes.HOME} state={state} />;
  }

  // if (requiredLogout && isLoggedIn) {
  //   return <Navigate replace to={PageRoutes.HOME} />;
  // }

  if (!children) return <Outlet />;

  return <>{children}</>;
};
